import './form.scss';

export default function Form(props) {
    const { onSubmit, children, className } = props;
    return (
        <form className={`form ${className || ''}`} onSubmit={onSubmit}>
            {children}
        </form>
    );
}